module.exports = {"account":"เข้าสู่ระบบ","login":"เข้าสู่ระบบ","remember":"จำฉันไว้ในระบบ","email":"อีเมล์","password":"รหัสผ่าน","error":"กรุณากรอกข้อมูล","emailerror":"กรุณากรอกอีเมล์"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/login/TH.json
// module id = 912
// module chunks = 150